export var CONTRACT_PROVIDER_PAY = 'contract_provider_pay';
